<div class="body-content">
    <div class="d-flex flex-row justify-content-between">
        <button mat-button (click)="showClientList()">
            <mat-icon> format_list_bulleted</mat-icon>
        </button>
        <h1 class="webapp-title margin-top-md">Client Pipeline</h1>
    
    </div>
    <app-cards-board [clientCards]="getClientCards()"></app-cards-board>
</div>